<template>
  <v-checkbox
    v-model="computedValue"
    :input-value="computedValue"
    :color="config.color || '#65AD45'"
    :label="config.label || ''"
    :direction="config.direction || 'horizontal'"
    :hide-details="config.hideDetails || 'auto'"
    :dense="config.dense || false"
    :ripple="config.ripple || false"
    :indeterminate="config.indeterminate || false"
    :error-messages="getValidationErrors()"
    :error-count="getValidationErrors().length"
    :append-icon="config.appendIcon || undefined"
    :class="[disabled ? 'checkbox-field--disabled' : 'checkbox-field']"
    :disabled="disabled"
    @input="event => $emit('onInput', event)"
    @change="onChange"
    @onClick="event => $emit('onClick', event)"
  >
    <template
      #label
    >
      <slot name="label" />
    </template>
  </v-checkbox>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'CheckboxField',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    inputValue: {
      type: Boolean,
      default: undefined
    },
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    customFieldKey: {
      type: String,
      default: ''
    }
  },

  emits: [
    'onInput',
    'input',
    'change',
    'clear-validation-errors',
    'onClick'
  ],

  computed: {
    computedValue: {
      get () {
        return this.inputValue !== undefined ? this.inputValue : this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('onInput', val)
      }
    }
  },

  methods: {
    onChange (val) {
      this.$emit('change', !!val)
      this.$emit('clear-validation-errors')
      const { onChange } = this.config || {}
      if (typeof onChange === 'function') {
        onChange({
          data: val
        })
      }
    },

    getValidationErrors () {
      let messages = []
      const { key } = this.config || {}

      if (!key || typeof key !== 'string' || isEmpty(this.validationErrors) || this.disabled) {
        return messages
      }

      for (const errorKey in this.validationErrors) {
        if (errorKey === key) {
          messages = this.validationErrors[errorKey]
        }
        else if (errorKey === this.customFieldKey) {
          messages = this.validationErrors[errorKey]
        }
      }

      return messages
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-field {
  margin-top: 0;
}

::v-deep.checkbox-field > .v-input__control > .v-input__slot > .v-label {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
  color: #111827;
  line-height: 20px;
  font-weight: 500;
}

::v-deep.checkbox-field--disabled > .v-input__control > .v-input__slot > .v-label {
  font-family: 'Satoshi', sans-serif;
  font-size: 14px !important;
  color: #9CA3AF !important;
  line-height: 20px;
  font-weight: 500;
}

::v-deep.checkbox-field > .v-input__control > .v-input__slot > .v-input--selection-controls__input > i {
  color: #D1D5DB;
}

::v-deep {
  .checkbox-field > .v-input__control > .v-input__slot > .v-label {
    font-family: 'Satoshi', sans-serif;
    font-size: 14px;
    color: #111827;
    line-height: 20px;
    font-weight: 500;
  }

  .checkbox-field--disabled > .v-input__control > .v-input__slot > .v-label {
    font-family: 'Satoshi', sans-serif;
    font-size: 16px !important;
    color: #6B7280 !important;
    line-height: 20px;
    font-weight: 400;
  }
}
</style>
